/**
 * Client de l'API Capalys.
 *
 * Les types miroitent les modèles Pydantic du backend. Ils sont écrits à la main pour
 * l'instant : la génération depuis l'OpenAPI viendra quand l'API aura plus de trois
 * routes, sinon l'outillage coûte plus cher que ce qu'il fait gagner.
 */

import { apiFetch, detailOf } from "./http";

export type StratifyBy = "none" | "cavity" | "shift";

export interface Limits {
  center: number;
  lower: number;
  upper: number;
  zone_low_2: number;
  zone_low_1: number;
  zone_high_1: number;
  zone_high_2: number;
}

export interface Violation {
  rule: string;
  label: string;
  severity: "critique" | "majeure" | "mineure";
  direction: string;
  indices: number[];
}

export interface Capability {
  cp: number | null;
  cpk: number | null;
  pp: number | null;
  ppk: number | null;
  cpm: number | null;
  mean: number;
  sigma_within: number | null;
  sigma_overall: number | null;
  /** Affichée à côté des indices : c'est la réponse à « pourquoi pas la même valeur que Minitab ». */
  sigma_method: string;
  n_values: number;
  warnings: string[];
}

export interface Stratum {
  name: string;
  n_values: number;
  mean: number;
  stddev: number;
  cpk: number | null;
  mean_shift_sigma: number;
  spread_ratio: number;
  is_outlier: boolean;
  finding: string | null;
}

export interface CharacteristicView {
  characteristic_code: string;
  characteristic_name: string;
  unit: string;
  specification: { nominal: number; lsl: number; usl: number };
  chart_type: string;
  subgroup_size: number;
  timestamps: string[];
  location_points: number[];
  dispersion_points: number[];
  location_limits: Limits;
  dispersion_limits: Limits;
  values: number[];
  capability: Capability;
  violations: Violation[];
  strata: Stratum[];
  stratify_by: StratifyBy;
}

export async function fetchDemoCharacteristic(
  stratifyBy: StratifyBy,
): Promise<CharacteristicView> {
  const response = await apiFetch(
    `/v1/demo/characteristic?stratify_by=${stratifyBy}`,
  );
  if (!response.ok) {
    throw new Error(await detailOf(response));
  }
  return (await response.json()) as CharacteristicView;
}
